//global countdown timer
(function () {
  //refference the countdown div
  var countdownTimer = document.querySelector('.js-countdown');

  //if the div is visible set the data values
  if(countdownTimer != null){
    var countdown_start = countdownTimer.dataset.start;
    var countdown_end = countdownTimer.dataset.end;
    var countdown_date = countdownTimer.dataset.date;

  //set the units belonging to the countdown timer
  const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

  //the timer variable is equal to value entered in Shopify settings
  let timer = countdown_date,

    //new date based on our set time
    countDown = new Date(timer).getTime(),
    //our setInterval function evaluates and invokes the x variable at specified intervals - i.e seconds
    setCount = setInterval(function() {

      let now = new Date().getTime(),//todays date
          expiry = countDown - now; //expiry is our future date minus todays date

      document.getElementById("days").innerText = Math.floor(expiry / (day)),
      document.getElementById("hours").innerText = Math.floor((expiry % (day)) / (hour)),
      document.getElementById("minutes").innerText = Math.floor((expiry % (hour)) / (minute)),
      document.getElementById("seconds").innerText = Math.floor((expiry % (minute)) / second);

      //here we check if the countdown reachs 0, hide the coundown and clear the interval from the DOM
      if (expiry <= 0) {
        let countdown = document.getElementById("countdown");
        let countdownWrapper = document.querySelector(".tpro-wrapper-countdown");

        countdownTimer.innerHTML = '<p class="announcement-bar-message js-countdown">' + countdown_end + '</p>';
        countdown.style.display = "none";
        countdownWrapper.style.display = "none";
        clearInterval(setCount);
      //If the countdown date is in the future, show the message
      } else {
        countdownTimer.innerHTML = '<p class="announcement-bar-message js-countdown py-0">' + countdown_start + '</p>';
      }
      //seconds
    }, 0);
  }
})();
//end global countdown timer